import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { RESET_PASSWORD_HEADER, TERMSANDCONDITION_HEADER } from '../../App.config';

const TermsAndConditionsPage = (props) => {
    const [isAccepted, onAccept] = useState(false);
    const { register, control, setValue, getValues, getFieldState, formState: { errors } } = useForm();

    return (
        <div className="modal-dialog modal-dialog-centered terms-conditions-dialog" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                        {TERMSANDCONDITION_HEADER}
                    </h5>
                    <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => props.closeRemoveModal()}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Tabs
                        defaultActiveKey="eng"
                        id="uncontrolled-tab-example"
                        className="mb-3"
                        variant='pills'
                    >
                        <Tab eventKey="eng" title="ENG" tabClassName='btn btn-xs'  >
                            <h6>The user understands and agrees to the following:
                            </h6>
                            <ul className="terms-conditions tc-symbol">
                                <li>Passwords and access to the portal must always be kept secure at all times and all passwords and access will not be shared with, nor used by, any other person or entity.
                                </li>
                                <li>Information in the portal is confidential and shall only be used for the intended purposes.
                                </li>
                                <li>The portal will not be accessed from a public terminal.
                                </li>
                            </ul>
                            <div className="p-2">
                                <div className="Check-box">
                                    <div>
                                        <input
                                            className="styled-checkbox"
                                            type="checkbox"
                                            id="levelFileUpload"
                                            name="levelFileUpload"
                                            // {...register("hasAccepted", { value: isAccepted })}
                                            checked={isAccepted}
                                            onChange={(e) => {
                                                onAccept(e.target.checked)
                                            }}
                                        />
                                        <label htmlFor="levelFileUpload">
                                            <span>
                                                <u>By clicking, ‘Accept’, you are accepting these terms and conditions of use.</u>
                                            </span>
                                            <span className='terms-conditions-violation-block'>
                                                Any violation of the above provisions may result in suspension or termination of user privileges and the imposition of any penalties as prescribed by applicable Provincial and Federal laws.
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </Tab>
                        <Tab eventKey="fr" title="FR">
                            <h6>L’utilisateur comprend et accepte ce qui suit :
                            </h6>
                            <ul className="terms-conditions tc-symbol">
                                <li>Les mots de passe et l’accès au portail doivent être conservés en toute sécurité à tout moment et tous les mots de passe et accès ne seront ni divulgués ni utilisés par une autre personne ou entité.
                                </li>
                                <li>Les renseignements contenus dans le portail sont confidentiels et ne doivent être utilisés qu’aux fins prévues.
                                </li>
                                <li>Le portail ne sera pas accessible à partir d’un terminal public.
                                </li>
                            </ul>
                            <div className="p-2">
                                <div className="Check-box">
                                    <div>
                                        <input
                                            className="styled-checkbox"
                                            type="checkbox"
                                            id="levelFileUpload"
                                            name="levelFileUpload"
                                            checked={isAccepted}
                                            onChange={(e) => {
                                                onAccept(e.target.checked)
                                            }}
                                        />
                                        <label htmlFor="levelFileUpload">
                                            <span>
                                                <u>En cliquant sur « Accepter », vous acceptez ces modalités.</u>
                                            </span>
                                            <span className='terms-conditions-violation-block'>
                                                Toute violation des dispositions ci-dessus peut entraîner la suspension ou la résiliation des privilèges de l’utilisateur et l’imposition de toute sanction prévue par les lois provinciales et fédérales applicables.
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </Tab>
                    </Tabs>
                </div>

                <div className="modal-footer">
                    <button disabled={!isAccepted} onClick={() => { props.onAccept() }} className='btn btn-primary btn-sm'>
                        Accept / Accepter
                    </button>
                </div>
            </div>
        </div>
    )
}

export default TermsAndConditionsPage;